// Traductions FR (principal) + NL (Belgique).
// Le contenu profond (fiches produits, articles de blog, mentions légales)
// reste en FR pour l'instant ; l'interface et la page d'accueil sont bilingues.

export const translations = {
  fr: {
    // Annonces (rotatif)
    "ann.1": "Livraison offerte dès 45 € · Belgique & France",
    "ann.2": "Ingrédients certifiés bio ECOCERT · Formulés au Maroc",
    "ann.3": "Paiement sécurisé · Bancontact · Visa · Mastercard",
    // Navigation
    "nav.home": "Accueil",
    "nav.shop": "Boutique",
    "nav.allProducts": "Tous les produits",
    "nav.heritage": "Héritage",
    "nav.ethics": "Éthique",
    "nav.rituals": "Rituels",
    "nav.contact": "Contact",
    "nav.cart": "Panier",
    // Commun
    "common.addToCart": "Ajouter au panier",
    "common.added": "Ajouté",
    "common.buyNow": "Acheter maintenant",
    "product.soldOut": "Rupture de stock",
    "product.unavailable": "Indisponible",
    "common.viewAll": "Voir toute la collection →",
    "common.viewDetail": "Voir le détail",
    "common.discover": "Découvrir la collection",
    "common.ourHeritage": "Notre héritage",
    "common.learnMore": "En savoir plus →",
    "common.readMore": "Lire l'article →",
    // Hero
    "hero.eyebrow": "Cosmétiques naturels · Formulés depuis Marrakech",
    "hero.title": "La beauté ancestrale du Maroc",
    "hero.subtitle": "Cosmétiques naturels certifiés bio, formulés depuis Marrakech avec un savoir-faire transmis de génération en génération.",
    // Sections accueil
    "home.signatureTag": "Sélection signature",
    "home.signatureTitle": "Nos soins emblématiques",
    "home.signatureDesc": "Des formules pures, une éthique bio, et des résultats visibles — conformes aux plus hauts standards de la cosmétique européenne.",
    "home.heritageTag": "Culture Traditionnelle du Maroc",
    "home.natureTag": "La Nature Marocaine",
    "home.ingredientsTag": "Des ingrédients d'exception",
    "home.ingredientsTitle": "La richesse du terroir marocain",
    "home.lookbookTag": "Le Rituel",
    "home.lookbookTitle": "Le Rituel Hammam",
    "home.lookbookDesc": "Recréez chez vous l'expérience du hammam traditionnel. Cliquez sur les pastilles pour découvrir les essentiels du rituel.",
    "home.reviewsTag": "Ce qu'elles en disent",
    "home.reviewsTitle": "Témoignages sincères",
    // Newsletter
    "nl.tag": "Rejoindre la Maison",
    "nl.title1": "Recevez nos conseils, rituels",
    "nl.title2": "et offres exclusives.",
    "nl.desc": "Rituels, ingrédients, saisons de récolte — et en avant-première, nos éditions limitées.",
    "nl.placeholder": "votre@email.com",
    "nl.button": "S'inscrire",
    // Footer
    "footer.tagline": "Née d'une passion pour les rituels de beauté ancestraux du Maroc. Une cosmétique lente, éthique et transparente, au service de votre éclat naturel.",
    "footer.house": "La Maison",
    "footer.service": "Service client",
    "footer.follow": "Suivez-nous",
    "footer.rights": "Tous droits réservés.",
    // Panier
    "cart.title": "Votre panier",
    "cart.empty": "Votre panier est vide",
    "cart.emptyDesc": "Découvrez nos rituels de beauté inspirés du Maroc.",
    "cart.summary": "Récapitulatif",
    "cart.subtotal": "Sous-total",
    "cart.shipping": "Livraison",
    "cart.free": "Offerte",
    "cart.total": "Total",
    "cart.checkout": "Passer la commande",
    "cart.continue": "Continuer mes achats",
    "cart.remaining": "Plus que {x} pour la livraison offerte.",
    // Blog
    "blog.tag": "Le Journal",
    "blog.title": "Rituels & Inspirations",
    "blog.subtitle": "Conseils beauté, secrets d'ingrédients et rituels marocains à adopter au quotidien.",
    "blog.error": "Le chargement des articles a échoué. Réessayez.",
    "blog.retry": "Réessayer",
    "blog.notFound": "Article introuvable",
    // Boutique
    "shop.tag": "Collection complète",
    "shop.title": "La Boutique <em>Nerolya</em>",
    "shop.subtitle": "Soins visage, corps et cheveux — tout l'art de la cosmétique marocaine, certifié bio.",
    // Fiche produit
    "pdp.story": "L'histoire",
    "pdp.usage": "Conseils d'utilisation",
    "pdp.inci": "Composition (INCI)",
    "pdp.shippingTitle": "Livraison & retours",
    "pdp.shippingText": "Livraison offerte dès {n}€ (2–4 jours ouvrés). Retours gratuits sous 30 jours, satisfaite ou remboursée.",
    "pdp.relatedTag": "Vous aimerez aussi",
    "pdp.relatedTitle": "Compléter le <em>rituel</em>",
    "pdp.outOfStock": "Rupture de stock",
    "pdp.notifyTitle": "Prévenez-moi lorsque ce produit est à nouveau disponible",
    "pdp.notifyPlaceholder": "Votre adresse email",
    "pdp.notifyButton": "Prévenez-moi",
    "pdp.notifySending": "Envoi…",
    // Cookies
    "cookie.title": "Votre vie privée nous importe",
    "cookie.text": "Nous utilisons des cookies pour mesurer l'audience (Google Analytics) et personnaliser nos campagnes (Meta). Vous pouvez accepter ou refuser librement.",
    "cookie.more": "En savoir plus",
    "cookie.accept": "Accepter",
    "cookie.refuse": "Refuser",
  },
  nl: {
    "ann.1": "Gratis verzending vanaf € 45 · België & Frankrijk",
    "ann.2": "Biologisch gecertificeerde ingrediënten ECOCERT · Bereid in Marokko",
    "ann.3": "Veilig betalen · Bancontact · Visa · Mastercard",
    "nav.home": "Home",
    "nav.shop": "Shop",
    "nav.allProducts": "Alle producten",
    "nav.heritage": "Erfgoed",
    "nav.ethics": "Ethiek",
    "nav.rituals": "Rituelen",
    "nav.contact": "Contact",
    "nav.cart": "Winkelmand",
    "common.addToCart": "Toevoegen",
    "common.added": "Toegevoegd",
    "common.buyNow": "Nu kopen",
    "product.soldOut": "Uitverkocht",
    "product.unavailable": "Niet beschikbaar",
    "common.viewAll": "Bekijk de volledige collectie →",
    "common.viewDetail": "Bekijk detail",
    "common.discover": "Ontdek de collectie",
    "common.ourHeritage": "Ons erfgoed",
    "common.learnMore": "Meer weten →",
    "common.readMore": "Lees het artikel →",
    "hero.eyebrow": "Natuurlijke cosmetica · Bereid in Marrakech",
    "hero.title": "De eeuwenoude schoonheid van Marokko",
    "hero.subtitle": "Natuurlijke, biologisch gecertificeerde cosmetica, bereid in Marrakech met een vakkennis die van generatie op generatie wordt doorgegeven.",
    "home.signatureTag": "Signatuurselectie",
    "home.signatureTitle": "Onze iconische verzorging",
    "home.signatureDesc": "Pure formules, een biologische ethiek en zichtbare resultaten — volgens de hoogste normen van de Europese cosmetica.",
    "home.heritageTag": "Traditionele cultuur van Marokko",
    "home.natureTag": "De Marokkaanse natuur",
    "home.ingredientsTag": "Uitzonderlijke ingrediënten",
    "home.ingredientsTitle": "De rijkdom van de Marokkaanse bodem",
    "home.lookbookTag": "Het Ritueel",
    "home.lookbookTitle": "Het Hammam-ritueel",
    "home.lookbookDesc": "Beleef thuis de ervaring van de traditionele hammam. Klik op de stippen om de essentiële producten te ontdekken.",
    "home.reviewsTag": "Wat zij ervan zeggen",
    "home.reviewsTitle": "Oprechte getuigenissen",
    "nl.tag": "Word lid van het Huis",
    "nl.title1": "Ontvang onze tips, rituelen",
    "nl.title2": "en exclusieve aanbiedingen.",
    "nl.desc": "Rituelen, ingrediënten, oogstseizoenen — en in primeur onze gelimiteerde edities.",
    "nl.placeholder": "uw@email.com",
    "nl.button": "Inschrijven",
    "footer.tagline": "Ontstaan uit een passie voor de eeuwenoude schoonheidsrituelen van Marokko. Trage, ethische en transparante cosmetica, ten dienste van uw natuurlijke uitstraling.",
    "footer.house": "Het Huis",
    "footer.service": "Klantenservice",
    "footer.follow": "Volg ons",
    "footer.rights": "Alle rechten voorbehouden.",
    "cart.title": "Uw winkelmand",
    "cart.empty": "Uw winkelmand is leeg",
    "cart.emptyDesc": "Ontdek onze schoonheidsrituelen geïnspireerd op Marokko.",
    "cart.summary": "Overzicht",
    "cart.subtotal": "Subtotaal",
    "cart.shipping": "Verzending",
    "cart.free": "Gratis",
    "cart.total": "Totaal",
    "cart.checkout": "Bestelling plaatsen",
    "cart.continue": "Verder winkelen",
    "cart.remaining": "Nog {x} voor gratis verzending.",
    "blog.tag": "Het Journaal",
    "blog.title": "Rituelen & Inspiratie",
    "blog.subtitle": "Schoonheidstips, geheimen van ingrediënten en Marokkaanse rituelen voor elke dag.",
    "blog.error": "Het laden van de artikelen is mislukt. Probeer opnieuw.",
    "blog.retry": "Opnieuw proberen",
    "blog.notFound": "Artikel niet gevonden",
    "shop.tag": "Volledige collectie",
    "shop.title": "De <em>Nerolya</em> Boetiek",
    "shop.subtitle": "Verzorging voor gezicht, lichaam en haar — de kunst van de Marokkaanse cosmetica, biologisch gecertificeerd.",
    "pdp.story": "Het verhaal",
    "pdp.usage": "Gebruiksadvies",
    "pdp.inci": "Samenstelling (INCI)",
    "pdp.shippingTitle": "Verzending & retour",
    "pdp.shippingText": "Gratis verzending vanaf {n}€ (2–4 werkdagen). Gratis retour binnen 30 dagen, tevreden of terugbetaald.",
    "pdp.relatedTag": "Dat vindt u vast ook mooi",
    "pdp.relatedTitle": "Maak het <em>ritueel</em> compleet",
    "pdp.outOfStock": "Niet op voorraad",
    "pdp.notifyTitle": "Breng mij op de hoogte zodra dit product weer beschikbaar is",
    "pdp.notifyPlaceholder": "Uw e-mailadres",
    "pdp.notifyButton": "Breng mij op de hoogte",
    "pdp.notifySending": "Verzenden…",
    "cookie.title": "Uw privacy is belangrijk voor ons",
    "cookie.text": "We gebruiken cookies om ons publiek te meten (Google Analytics) en onze campagnes te personaliseren (Meta). U kunt vrij accepteren of weigeren.",
    "cookie.more": "Meer weten",
    "cookie.accept": "Accepteren",
    "cookie.refuse": "Weigeren",
  },
};
